module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAABO0lEQVQ4T9WTsUrEQBCGZ/YiCeIbiGBl5VPcCfcAVmJhmtkTIWCphYKgoo3N2WSSFOYB7C18Bzv7O+1Em8MYstmRhVxzeHJ32Ljdz85+zP/vDBJRFxETAFiDxc5QRAi11gNrbWSMeViE43leVyl160Di+37Q7/fLRUBRFPllWX79A5DW+gYA3pj50lnVWp+LiCRJctLoCwComfnU6anWtNaHAPDBzHeusNfr7TsQM8dOE9GBUsrEccy/guYN/O/DJiKLiCvM/DlvN01myyIyct//JCL3rVbrcRqoqqrnLMve3X0YhutBEKyOa+u67gDANhLRBiJei8i0FVlSSvlFUXTyPH8loisA2BqDEHFojDnCWewQ0Rki7lhr22mavvz0ZiZQk4Wboz0AaDPzYBI2M6iZoWNE3GTm3UnQN8SHumxFNQtLAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/front/message_icon.png
// module id = j5/s
// module chunks = 1